var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.391,
    height: 27.95,
    viewBox: "0 0 25.391 27.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "game_icon",
    "data-name": "game icon",
    transform: "translate(-19903.338 -2376.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17402",
    "data-name": "Path 17402",
    d: "M12.244,14.768a.577.577,0,0,0-.525.623l.052.623a.577.577,0,0,0,.577.525H12.4a.577.577,0,0,0,.525-.629l-.058-.617A.577.577,0,0,0,12.244,14.768Z",
    transform: "translate(19893.77 2366.711)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17403",
    "data-name": "Path 17403",
    d: "M32.939,22.182l-1.39-1.39A7.183,7.183,0,0,0,26.6,8.883l.046-1.108a1.39,1.39,0,0,0-1.339-1.454L13.5,5.779a1.39,1.39,0,0,0-1.46,1.327L11.961,8.79l-2.694.237A1.39,1.39,0,0,0,8,10.521l1.731,19.53a1.4,1.4,0,0,0,1.512,1.269l7.974-.7,2.631,2.66a1.529,1.529,0,0,0,.681.392,1.506,1.506,0,0,0,.785,0l7.062-1.892a1.506,1.506,0,0,0,1.067-1.067l1.892-7.056A1.535,1.535,0,0,0,32.939,22.182Zm-2.2-2.2L30,19.239a5.193,5.193,0,0,0,.623-.964l.992.352A6.237,6.237,0,0,1,30.74,19.983Zm-4.281-7.731a3.837,3.837,0,0,1,2.735,6.179l-1.408-1.408a1.529,1.529,0,0,0-1.465-.392h-.063ZM32,17.549l-.981-.352a5.274,5.274,0,0,0,.1-1.483l1.027-.185a5.891,5.891,0,0,1-.167,2.008Zm-.035-3.121-1.039.19a5.1,5.1,0,0,0-.623-1.315l.767-.7a6.012,6.012,0,0,1,.877,1.812ZM28.721,10.6a6.145,6.145,0,0,1,1.65,1.154l-.808.687a5.048,5.048,0,0,0-1.2-.825Zm-1.108-.4-.352.992a4.823,4.823,0,0,0-.767-.1l.046-1.039A5.937,5.937,0,0,1,27.613,10.2ZM13.189,7.158a.242.242,0,0,1,.254-.231L25.265,7.5a.237.237,0,0,1,.231.248l-.427,9.231-.577.156L23.8,9.2a1.4,1.4,0,0,0-1.512-1.269L13.12,8.7ZM11.118,30.19a.242.242,0,0,1-.26-.213L9.151,10.446a.242.242,0,0,1,.219-.26L22.392,9.033a.237.237,0,0,1,.254.219l.715,8.147-1.927.513a3.329,3.329,0,0,0-.479-.508l-4.3-3.594a.577.577,0,0,0-.814.069l-3.612,4.3a3.11,3.11,0,0,0,.237,4.287,3.046,3.046,0,0,0,2.648.7,3.317,3.317,0,0,1-.577.779.58.58,0,0,0,.387,1h.052l1.783-.156-.479,1.887a1.523,1.523,0,0,0,.375,1.437l1.483,1.448ZM17.09,23.6l-.94.081a3.743,3.743,0,0,0,.179-.34.992.992,0,0,0-.144-1.108.975.975,0,0,0-1.056-.271,1.875,1.875,0,0,1-1.892-.358,1.95,1.95,0,0,1-.115-2.683l3.237-3.86,3.814,3.2-.929.248a1.517,1.517,0,0,0-1.073,1.073Zm13.235,6.808a.369.369,0,0,1-.26.26L23,32.561a.369.369,0,0,1-.346-.115l-5.164-5.193a.352.352,0,0,1-.1-.352l1.892-7.062a.369.369,0,0,1,.26-.26L26.6,17.733h0a.4.4,0,0,1,.185,0,.381.381,0,0,1,.167.1l5.193,5.193a.358.358,0,0,1,.1.352Z",
    transform: "translate(19895.346 2370.514)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17404",
    "data-name": "Path 17404",
    d: "M33.929,35.324l-5.044-4.95a.583.583,0,1,0-.831.819l5.044,4.95a.664.664,0,0,1,.167.629L31.55,43.414a.577.577,0,0,0,.41.71.629.629,0,0,0,.15,0,.577.577,0,0,0,.577-.427L34.4,37.055A1.8,1.8,0,0,0,33.929,35.324Z",
    transform: "translate(19886.146 2359.431)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17405",
    "data-name": "Path 17405",
    d: "M46.387,35.733a.577.577,0,0,0-.7-.4l-7.505,1.928a.579.579,0,0,0,.173,1.137.663.663,0,0,0,.15,0L46,36.46a.577.577,0,0,0,.387-.727Z",
    transform: "translate(19882.016 2357.722)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17406",
    "data-name": "Path 17406",
    d: "M30.44,44.653a1.624,1.624,0,0,0,.385,1.431c.334.34.706.244.828-.218a1.624,1.624,0,0,0-.385-1.431C30.934,44.082,30.562,44.2,30.44,44.653Z",
    transform: "translate(19885.918 2354.139)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17407",
    "data-name": "Path 17407",
    d: "M29.033,36.71a1.624,1.624,0,0,0-.385-1.431c-.334-.334-.706-.237-.828.218a1.623,1.623,0,0,0,.385,1.431C28.564,37.269,28.911,37.172,29.033,36.71Z",
    transform: "translate(19886.973 2357.951)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17408",
    "data-name": "Path 17408",
    d: "M30.3,41.29a1.623,1.623,0,0,0-.385-1.431c-.334-.334-.706-.237-.828.218a1.623,1.623,0,0,0,.385,1.431C29.834,41.849,30.207,41.752,30.3,41.29Z",
    transform: "translate(19886.344 2356.122)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17409",
    "data-name": "Path 17409",
    d: "M39.071,32.58a.456.456,0,0,0,.193-.815,1.63,1.63,0,0,0-1.431-.385.449.449,0,0,0-.218.828A1.624,1.624,0,0,0,39.071,32.58Z",
    transform: "translate(19882.59 2359.698)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17410",
    "data-name": "Path 17410",
    d: "M45.4,39.9a1.63,1.63,0,0,0-1.046,1.052c-.122.456.154.725.642.6a1.637,1.637,0,0,0,1.046-1.052C46.157,40.051,45.882,39.782,45.4,39.9Z",
    transform: "translate(19879.877 2356.245)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17411",
    "data-name": "Path 17411",
    d: "M38.58,46.533a1.637,1.637,0,0,0-1.046,1.046c-.122.456.154.725.642.6a1.63,1.63,0,0,0,1.053-1.046C39.318,46.675,39.042,46.411,38.58,46.533Z",
    transform: "translate(19883.426 2352.827)",
    fill: "#d4d4d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.2203a0bd8c6ec2400057a79ca915eaa2.svg";
export { ForwardRef as ReactComponent };